import { render, staticRenderFns } from "./userSubscribeMenu.vue?vue&type=template&id=19058ae8&scoped=true"
import script from "./userSubscribeMenu.vue?vue&type=script&lang=js"
export * from "./userSubscribeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19058ae8",
  null
  
)

export default component.exports